<template>
    <b-modal v-if="!loading" id="product_model_form" ref="product_model_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add Product Models' : 'Edit Product Models' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.code" :class="{'border-danger': 'code' in errors}"
                                      @input="'code' in errors ? delete errors.code : ''"
                                      autocomplete="off" placeholder="Code"/>

                        <b-form-invalid-feedback :state="!'code' in errors"
                                                 v-text="'code' in errors ? errors.code[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Description" class="has-float-label">
                        <template v-slot:label>
                            <span>Description <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.description" :class="{'border-danger': 'description' in errors}"
                                      @input="'description' in errors ? delete errors.description : ''"
                                      autocomplete="off" placeholder="Description"/>

                        <b-form-invalid-feedback :state="!'description' in errors"
                                                 v-text="'description' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('product_model_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitProductModels">Submit</state-button>

            <state-button v-else variant="primary" :click="updateProductModels">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "ProductModelsFormModal",

        components: {
            StateButton,
        },

        props: [
            'edit'
        ],

        data() {
            return {
                loading: true,
            }

        },

        computed: {
            ...mapGetters({
                form: 'getProductModelsForm',
                errors: 'getProductModelsErrors',
            })
        },

        mounted() {
            this.loading = false;
        },

        methods: {
            resetForm() {
                this.$store.commit('setProductModelsForm');
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            submitProductModels() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitProductModel', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Added new model!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_model_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            updateProductModels() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('updateProductModel', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Updated the product model!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_model_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            }

        }
    }
</script>

<style scoped>

</style>
